var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrdersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 8C14.4477 8 14 7.55228 14 7V5C14 4.44772 14.4477 4 15 4H19C19.5523 4 20 4.44772 20 5V7C20 7.55229 19.5523 8 19 8H15ZM5 12C4.44772 12 4 11.5523 4 11V5C4 4.44772 4.44772 4 5 4H9C9.55228 4 10 4.44772 10 5V11C10 11.5523 9.55228 12 9 12H5ZM15 20C14.4477 20 14 19.5523 14 19V13C14 12.4477 14.4477 12 15 12H19C19.5523 12 20 12.4477 20 13V19C20 19.5523 19.5523 20 19 20H15ZM5 20C4.44772 20 4 19.5523 4 19V17C4 16.4477 4.44772 16 5 16H9C9.55228 16 10 16.4477 10 17V19C10 19.5523 9.55229 20 9 20H5Z",
    stroke: "#fff",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrdersIcon);
export default __webpack_public_path__ + "static/media/ordersIcon.ee05aa017d0b70cc755107cb028555ff.svg";
export { ForwardRef as ReactComponent };